const ButtonHamburguer = ({ navOpen, setNavOpen }) => {
    return (
        <button
            type="button"
            className="lg:hidden inline-flex items-center justify-center p-2 rounded-md
                        hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/80"
            onClick={() => setNavOpen((v) => !v)}
            aria-label="Abrir menú de navegación"
        >
            <svg
                className="h-6 w-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {navOpen ? (
                    <>
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </>
                ) : (
                    <>
                        <line x1="3" y1="6" x2="21" y2="6" />
                        <line x1="3" y1="12" x2="21" y2="12" />
                        <line x1="3" y1="18" x2="21" y2="18" />
                    </>
                )}
            </svg>
        </button>
    );
};

export default ButtonHamburguer;
